export const google = {
  seo: {
    title: 'Google integration | Bistroo',
    description: 'Let customers order directly from Google at your restaurant. Bistroo handles the Order with Google connection — no volume-fee, full ownership.',
  },
  hero: {
    category: 'Online visibility',
    description: 'Let customers order directly from Google Search and Google Maps at your restaurant, without going through an ordering service.',
  },
  about: {
    title: 'What does the Google integration do?',
    p1: 'Via "Order with Google" customers can see an order button directly in Google search results and on Google Maps. They click "Order" and land on your Bistroo webshop — your own channel, your brand identity, your margin.',
    p2: 'Bistroo handles the entire technical connection with Google. You only need to verify your Google Business Profile. After that, your restaurant is visible to millions of people who search for food nearby every day.',
    stats_title: 'More than 8.5 billion searches per day',
    stats_subtitle: 'Google is the world\'s largest food delivery discovery source.',
    benefits_title: 'Benefits of the Google connection',
    benefits: [
      'Direct order button in Google Search and Maps',
      'No volume-fee to external ordering services',
      'Menu automatically synchronized via Bistroo',
      'Increased online visibility for your restaurant',
      'Works alongside your existing Bistroo webshop',
    ],
  },
  wordcloud_title: 'Google at a glance',
  wordcloud: ['Order with Google', 'Google Maps', 'Google Search', 'SEO', 'Local visibility', 'Business Profile', 'Star ratings', 'Opening hours', 'Menu display', 'Order button', 'Free channel', 'Discover', 'Maps pin', 'Search engine marketing', 'Customer discovery'],
  usp: {
    heading: 'Why connect Bistroo to Google?',
    items: [
      { icon: 'bi-search', title: 'Get found for free', text: 'Millions of people search for food nearby on Google every day. With an order button you stand out immediately, without an advertising budget.' },
      { icon: 'bi-cursor-fill', title: 'Fewer drop-offs', text: 'Customers who can order directly in Google don\'t need to click through to an external ordering service. Fewer steps = more orders.' },
      { icon: 'bi-piggy-bank-fill', title: 'No volume-fee', text: 'Order with Google sends customers to your own Bistroo webshop. No volume-fee to Google, no middleman, 100% your revenue.' },
      { icon: 'bi-star-fill', title: 'Reviews convert', text: 'Your Google reviews are directly visible next to your order button. More stars means more trust and more clicks.' },
      { icon: 'bi-geo-alt-fill', title: 'Visible in Google Maps', text: 'In addition to Google Search, your order button also appears in Google Maps. Customers who find your restaurant on the map order directly.' },
      { icon: 'bi-patch-check-fill', title: 'Business profile always up to date', text: 'Bistroo synchronises your opening hours and menu with your Google Business Profile. Customers always see the correct information without double work.' },
    ],
  },
  setup: {
    heading: 'How to appear on Google',
    steps: [
      'Make sure your Google Business Profile is fully completed and verified.',
      'Open Bistroo Merchant Portal → Integrations → Google.',
      'Click "Connect with Google" and authorize the connection.',
      'Bistroo automatically synchronizes your menu with Google.',
      'The order button appears within 1–3 business days in Google Search and Maps.',
    ],
  },
  faq: {
    items: [
      { q: 'Does the Google integration cost extra?', a: 'No. The Order with Google integration is included in all Bistroo subscriptions. You only pay your regular Bistroo subscription fee.' },
      { q: 'How long does it take before I am visible on Google?', a: 'After activation it takes on average 1 to 3 business days for the order button to appear in Google Search and Maps. Google needs to process the connection internally.' },
      { q: 'Is my menu automatically updated on Google?', a: 'Yes. Bistroo automatically synchronizes your menu changes with Google. Price updates or new dishes are typically visible within 24 hours.' },
      { q: 'In which regions does Order with Google work?', a: 'Order with Google is active in the Netherlands and a growing number of other countries. Check the Bistroo support centre for current availability per region.' },
      { q: 'Can I combine Google orders with my regular Bistroo webshop?', a: 'Absolutely. Orders via Google arrive on the same Bistroo dashboard as orders via your own webshop. Everything is centrally manageable.' },
    ],
  },
}
